import React from 'react';
import {
  Card,
  Checkbox,
  FormControlLabel,
  FormGroup,
  TextField,
  Tooltip,
  Typography,
} from '@mui/material';
import PropTypes from 'prop-types';
import styles from './styles';
import { useNotes } from '../hooks/useNotes';

const Notes = ({
  promotionData,
  setPromotionData,
  loadedPromotionData,
  mode,
  isNotesClickable,
  fetchHeadlineData,
  historicPromotionData,
}) => {
  const { includeNotes, notes, isDisabled, handleNoteInclude, handleNotes, getTooltipText } =
    useNotes({
      promotionData,
      setPromotionData,
      loadedPromotionData,
      mode,
      fetchHeadlineData,
      historicPromotionData,
    });

  return (
    <section>
      <Typography style={styles.heading}>Notes</Typography>

      {isNotesClickable !== undefined && !isNotesClickable ? (
        <div style={{ position: 'relative', width: 'fit-content' }}>
          <Tooltip
            arrow
            placement="top"
            leaveDelay={500}
            sx={styles.freezeDateTooltip}
            title={'Please select a branch to include notes'}
          >
            <FormGroup>
              <FormControlLabel
                control={<Checkbox checked={false} />}
                label="Include"
                sx={{ width: 'fit-content' }}
              />
            </FormGroup>
          </Tooltip>
        </div>
      ) : (
        <div style={{ position: 'relative', width: 'fit-content' }}>
          <Tooltip
            arrow
            placement="top"
            leaveDelay={500}
            sx={styles.freezeDateTooltip}
            title={getTooltipText()}
          >
            <FormGroup>
              <FormControlLabel
                control={<Checkbox checked={includeNotes} onChange={handleNoteInclude} />}
                label="Include"
                disabled={isDisabled}
              />
            </FormGroup>
          </Tooltip>
        </div>
      )}

      <Card
        sx={
          !includeNotes
            ? { marginTop: '20px', marginBottom: '70px', ...styles.cardBox, ...styles.disableCard }
            : { marginTop: '20px', marginBottom: '70px', ...styles.cardBox }
        }
      >
        <div className="notes" style={{ padding: '10px 20px' }}>
          <p style={{ ...styles.headingSmall, paddingTop: '5px' }}>
            Notes: &nbsp;{' '}
            <span style={{ background: 'rgb(255, 228, 51)', wordWrap: 'break-word' }}>
              {notes || historicPromotionData?.notes}
            </span>
          </p>
          <TextField
            variant="standard"
            multiline
            label={notes ? '' : 'Type your note'}
            disabled={isDisabled}
            value={notes || promotionData?.notes}
            onChange={(event) => {
              handleNotes(event.target.value);
            }}
            sx={{ width: '100%' }}
          />
        </div>
      </Card>
    </section>
  );
};

Notes.propTypes = {
  promotionData: PropTypes.object,
  setPromotionData: PropTypes.func.isRequired,
  loadedPromotionData: PropTypes.bool.isRequired,
  mode: PropTypes.string,
  isNotesClickable: PropTypes.bool,
  fetchHeadlineData: PropTypes.func.isRequired,
  historicPromotionData: PropTypes.shape({
    notes: PropTypes.string,
  }),
};

export default Notes;
